import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Container, 
  IconButton, 
  Box,
  Grid,
  Avatar
} from '@mui/material';
import { Close } from '@mui/icons-material';

const AboutUs = ({ open, onClose }) => {
  const teamMembers = [
    {
      name: 'Jane Doe',
      position: 'CEO & Founder',
      bio: 'Jane has over 15 years of experience in search technology and previously led engineering teams at major tech companies.'
    },
    {
      name: 'John Smith',
      position: 'CTO',
      bio: 'John specializes in machine learning algorithms and has published several papers on efficient search methodologies.'
    },
    {
      name: 'Emily Chen',
      position: 'Head of Product',
      bio: 'Emily brings 10 years of product management experience and is passionate about creating intuitive user experiences.'
    }
  ];

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" color="#0d9488">
            About Us
          </Typography>
          <IconButton onClick={onClose} aria-label="close">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent dividers>
        <Container>
          <Typography variant="h6" gutterBottom>
            Our Mission
          </Typography>
          <Typography paragraph>
            At Searcheble, we're on a mission to revolutionize how organizations access and utilize their internal knowledge. 
            We believe that every team should have instant access to the information they need, when they need it, 
            without wasting time searching through scattered documents and systems.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Our Story
          </Typography>
          <Typography paragraph>
            Founded in 2022, Searcheble was born out of frustration with existing search solutions that failed to 
            connect people with the information they needed. Our founders, having worked at large enterprises, 
            experienced firsthand how much time knowledge workers waste searching for information.
          </Typography>
          <Typography paragraph>
            What started as an internal tool quickly evolved into a powerful platform that now helps 
            companies of all sizes centralize and access their knowledge instantly.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Our Values
          </Typography>
          <Typography component="ul" gutterBottom>
            <li><strong>Simplicity:</strong> We believe powerful technology should be easy to use.</li>
            <li><strong>Transparency:</strong> We're open about how our technology works and our business practices.</li>
            <li><strong>Continuous Improvement:</strong> We're never satisfied and always evolving our platform.</li>
            <li><strong>Customer Success:</strong> Your success is our success - we're partners in your journey.</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Our Team
          </Typography>
          <Typography paragraph>
            We're a diverse team of engineers, designers, and business professionals united by our passion for 
            making information accessible.
          </Typography>

          <Grid container spacing={3} sx={{ mt: 2 }}>
            {teamMembers.map((member, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  <Avatar 
                    sx={{ 
                      width: 100, 
                      height: 100, 
                      bgcolor: '#0d9488', 
                      margin: '0 auto', 
                      mb: 2 
                    }}
                  >
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </Avatar>
                  <Typography variant="h6">{member.name}</Typography>
                  <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                    {member.position}
                  </Typography>
                  <Typography variant="body2">{member.bio}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </DialogContent>
    </Dialog>
  );
};

export default AboutUs;